import React from "react";
import Select, { components } from "react-select";

const FilaZeroSelect = ({
  name,
  value,
  options = [],
  onChange,
  placeholder = "Selecione",
  isDisabled = false,
  isSearchable = true,
  className = "",
  leadingIcon = null,
  ariaLabel,
  maxMenuHeight = 260,
}) => {
  const selectedOption =
    options.find((option) => String(option.value) === String(value ?? "")) || null;

  const Control = (props) => (
    <components.Control {...props}>
      {leadingIcon && (
        <span
          aria-hidden="true"
          style={{
            display: "inline-flex",
            flexShrink: 0,
            marginLeft: 12,
            color: props.isFocused ? "#ff5a00" : "#667085",
          }}
        >
          {leadingIcon}
        </span>
      )}
      {props.children}
    </components.Control>
  );

  return (
    <Select
      className={className}
      inputId={name}
      name={name}
      value={selectedOption}
      options={options}
      placeholder={placeholder}
      isDisabled={isDisabled}
      isSearchable={isSearchable}
      noOptionsMessage={() => "Nenhuma opção encontrada"}
      onChange={(option) =>
        onChange?.({ target: { name, value: option?.value ?? "" } })
      }
      aria-label={ariaLabel || placeholder}
      components={leadingIcon ? { Control } : undefined}
      menuPortalTarget={typeof document !== "undefined" ? document.body : null}
      menuPosition="fixed"
      menuPlacement="auto"
      maxMenuHeight={maxMenuHeight}
      styles={{
        control: (base, state) => ({
          ...base,
          minHeight: 48,
          borderRadius: 8,
          borderColor: state.isFocused ? "#ff5a00" : "#d8dee8",
          boxShadow: state.isFocused
            ? "0 0 0 3px rgba(255, 90, 0, 0.12)"
            : "none",
          backgroundColor: state.isDisabled ? "#f3f4f6" : "#fff",
          cursor: state.isDisabled ? "not-allowed" : "pointer",
          "&:hover": { borderColor: "#ff5a00" },
        }),
        valueContainer: (base) => ({ ...base, padding: "4px 12px" }),
        placeholder: (base) => ({ ...base, color: "#98a2b3" }),
        singleValue: (base) => ({
          ...base,
          color: "#0f1b2d",
          fontWeight: 600,
        }),
        indicatorSeparator: () => ({ display: "none" }),
        dropdownIndicator: (base, state) => ({
          ...base,
          color: state.isFocused ? "#ff5a00" : "#667085",
          "&:hover": { color: "#ff5a00" },
        }),
        menuPortal: (base) => ({ ...base, zIndex: 2200 }),
        menu: (base) => ({
          ...base,
          marginTop: 6,
          borderRadius: 8,
          overflow: "hidden",
          boxShadow: "0 14px 34px rgba(15, 27, 45, 0.16)",
          border: "1px solid #d8dee8",
        }),
        menuList: (base) => ({
          ...base,
          padding: 6,
          maxHeight: maxMenuHeight,
        }),
        option: (base, state) => ({
          ...base,
          borderRadius: 6,
          marginBottom: 2,
          color: state.isSelected ? "#fff" : "#0f1b2d",
          backgroundColor: state.isSelected
            ? "#ff5a00"
            : state.isFocused
              ? "#fff3eb"
              : "#fff",
          fontWeight: state.isSelected ? 700 : 500,
          cursor: "pointer",
          ":active": { backgroundColor: "#fff3eb" },
        }),
      }}
    />
  );
};

export default FilaZeroSelect;
